const summaryByProjectColumns = ["Project", "Actual Hours", "Billed Hours"];

const summaryByProjectAndServiceColumns = [
  "Project",
  "Service Description",
  "Actual Hours",
  "Billed Hours"
];

const listColumns = [
  "Customer",
  "Project",
  "Service Description",
  "Stage",
  "Completed Date",
  "Assigned To",
  "Actual Hours",
  "Billed Hours",
  "Billing Description",
  "Internal Note"
];

export {
  summaryByProjectAndServiceColumns,
  summaryByProjectColumns,
  listColumns
};
